<template>
    <div class="inner-wrapper">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <!--<div class="page-title">
            <h1 class="float-left">Sales Orders</h1>
            <div class="title-right float-right">

            </div>
        </div>-->
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="filter-sec">
                                        <button type="button" class="btn filter-btn" @click="toggleShowFilters">
                                            <i class="ri-filter-line align-bottom me-1"></i> Filters
                                        </button>
                                    </div>
                                    <span class="listbtn-sec">
                                        <a href="javascript:void(0)" class="btn list-btn"
                                        @click="isListView=true;"
                                        :class="{'active': isListView == true}"><i class="ri-list-check align-bottom"></i></a>
                                        <a href="javascript:void(0)" class="btn list-btn"
                                        @click="isListView=false;"
                                        :class="{'active': isListView == false}"><i class="ri-grid-fill align-bottom"></i></a>

                                    </span>


                                </form>
                            </div>
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search" @submit.prevent="search(1)">

                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i class="ri-search-line search-icon"></i></button>
                                        </div>
                                        <input v-model="filterData.search_filter" type="text" class="form-control"
                                            placeholder="Quick Search">

                                    </div>

                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">
                                        <a v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-sales-order')" href="javascript:void(0)" @click="goToCreateSO" class="btn create-btn"><i class="ri-add-circle-line align-bottom me-1"></i>
                                            Create Order
                                        </a>
                                        <div class="quotes-text">{{ totalOrders }} Orders</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filter-row" v-if="showFilters">
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.status_search" @change="search(2)">
                                    <option :value="null">Status</option>
                                    <option v-for="(status, index) in filters.statuses" :value="status.id">
                                        {{ status.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.label_id" @change="search(2)">
                                    <option :value="null">Label</option>
                                    <option v-for="(item, index) in filters.labels" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <v-select label="text" :filterable="false"
                                        v-model="customer"
                                        :options="customers"
                                        placeholder="Customer"
                                        @input="onCustomerSelect"
                                        @search="onCustomerSearch"
                                        @selected="onCustomerSelect"
                                        @deselected="onCustomerDeSelect">
                                    <template slot="no-options">
                                        type to search customers..
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.html">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.text">
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.sale_user_id" @change="search(2)">
                                    <option :value="null">Sales REP</option>
                                    <option v-for="(sale_user, index) in filters.sale_users" :value="sale_user.id">
                                        {{ sale_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_added_user_id" @change="search(2)">
                                    <option :value="null">Added By</option>
                                    <option v-for="(admin_user, index) in filters.admin_users" :value="admin_user.id">
                                        {{ admin_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_by_date" @change="search(2)">
                                    <option :value="null">Time Frame</option>
                                    <option value="0">All Time</option>
                                    <option value="1">Today</option>
                                    <option value="2">This week</option>
                                    <option value="3">This Month</option>
                                    <option value="4"> This Year</option>
                                    <option value="5">Custom Range</option>
                                </select>
                            </div>
                            <div class="search-btnsec dl-flex">
                                <button class="btn btn-success" type="button" @click.prevent="search(2)"><i class="ri-search-line search-icon"></i>
                                </button>
                                <button class="btn btn-reset" type="button" @click="resetFilter"><i class="ri-refresh-line"></i>
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="showFilters">
                            <div class="col-md-3">
                                <date-picker v-if="filterData.search_by_date == 5" format="MM/DD/YYYY" @change="search(2)"
                                            v-model="filterData.date_range" range></date-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <template v-if="isListView">
                <OrderList :filterData="filterData"
                           :bus="bus" ref="orderList"
                           :is_draft="0"
                           @returnTotalNumOrders="setTotalOrders" @deleteItem="removeItem" @onDeleteMultiple="deleteMultiple"></OrderList>
            </template>
            <template v-else>
                <OrderGrid :filterData="filterData"
                           :bus="bus" ref="orderGrid"
                           @returnTotalNumOrders="setTotalOrders" @deleteItem="removeItem"></OrderGrid>
            </template>


        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

import OrderList from "../../components/OrderList";
import OrderGrid from "../../components/OrderGrid";
import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: "Orders",
    components: {
        OrderList, OrderGrid, DatePicker,
    },
    created() {

        this.getOrderFilters();
    },
    beforeMount() {
        let statusId = localStorage.getItem('soFilterStatus');
        if (typeof statusId != undefined && statusId != null && statusId != '') {
            this.showFilters = true;
            this.filterData.status_search = statusId;
            localStorage.removeItem('soFilterStatus');
        }
    },
    data() {
        return {
            bus: new Vue(),
            isListView: false,
            totalOrders: 0,
            showFilters: false,
            filters: {
                statuses: [],
                sale_users: [],
                admin_users: [],
                labels: [],
            },
            filterData: {
                search_filter: null,
                sale_user_id: null,
                search_customer_id: null,
                search_added_user_id: null,
                search_by_date: null,
                status_search: null,
                date_range: null,
                label_id: null
            },
            customers: [],
            customer: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading',
            'setLoading',
            'setSalesOrderMenuItems',
            'setPurchaseOrderMenuItems',
            'setNewOrder',
            'setOrdersShowFilters',
            'setOrdersFilterData'
        ]),
        resetFilter() {
            this.filterData = {
                search_filter: null,
                sale_user_id: null,
                search_customer_id: null,
                search_added_user_id: null,
                search_by_date: null,
                status_search: null,
                date_range: null,
                label_id: null
            };

            this.setOrdersFilterData(this.filterData);
            this.customer = null;
            this.search();
        },
        toggleShowFilters(){
            this.showFilters = !this.showFilters;

            this.setOrdersShowFilters(this.showFilters);
        },
        removeItem(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.delete(window.route('orders.destroy', {id: event.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.bus.$emit('resetOrderDeleteSelection');
                        self.bus.$emit('getOrders');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteMultiple(selectedOrdersForDelete){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('deleteSelectedOrders'), {ids: selectedOrdersForDelete}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.bus.$emit('getOrders');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        goToCreateSO() {
            this.setNewOrder({
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products: [],
                selectedProducts: [],
            });
            this.$router.push({name: 'selectCustomer'});
        },
        search(buttonIndex) {
            //if(buttonIndex == 1 && this.filterData.search_filter != null && this.filterData.search_filter.length > 2) {
            if(buttonIndex == 1) {
                this.bus.$emit('getOrders');
            } else {
                this.bus.$emit('getOrders');
            }
        },
        setTotalOrders(event) {
            this.totalOrders = event;
        },
        getOrderFilters() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.getFilters'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors && data.errors.length) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.filters = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        onCustomerSelect(event) {
            if (event) {
                this.filterData.search_customer_id = event.id;
            } else {
                this.filterData.search_customer_id = null;
            }

            this.search(2);
        },
        onCustomerDeSelect(event) {
            this.filterData.search_customer_id = null;
            this.search(2);
        },
        onCustomerSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchCustomer'), {searchTerm: search, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
    },
    watch: {
        '$route.query.status'() {
            this.filterData.status_search = this.$route.query.status;
            this.search();
        },
        filterData: {
            handler: function (after, before) {
                this.setOrdersFilterData(after);
            },
            deep: true,
        },
    },
    mounted() {
        if(this.salesOrderState) {
            this.showFilters = this.salesOrderState.showFilters;
            this.filterData = _.cloneDeep(this.salesOrderState.filterData);
        }
        let self = this;
        this.$root.$on('changeSOStatusFilter', (statusId) => {
            self.showFilters = self.salesOrderState.showFilters;
            self.filterData = _.cloneDeep(self.salesOrderState.filterData);

            if (typeof statusId != undefined && statusId != '') {
                self.filterData.status_search = statusId;
                self.showFilters = true;
                self.search();
            }
        });
        if (this.$route.query.status) {
            this.filterData.status_search = this.$route.query.status;
            this.search();
        }
    },
    computed: {
        ...mapState([
            'userState',
            'salesOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
